<template>
  <div class="name-result-content-container">
    <div class="title">宝宝的英文名</div>
    <div class="en-name">{{ result.englishName }}</div>
    <div class="en-name-mark">{{ result.phonetics }}</div>
    <div class="name-meaning-tags-box">
      <span v-for="t in tags" :key="t">{{ t }}</span>
    </div>
    <div class="ranking-text">·{{ result.ranking }}·</div>
    <div class="human-card-box">
      <div class="human-cover-box">
        <img
          :src="`${localhost ? '/h5' : ''}/static/nameimage/${faceImage}`"
          alt=""
        />
        <!-- 图片显示不出来的问题本地不好使，测试环境测试没有问题 -->
      </div>
      <div class="human-content-text">
        <div class="label">代表人物</div>
        <div class="image-name">
          {{ result.imgName }}
          <strong>/</strong>
          <span>{{ book }}</span>
        </div>
        <div class="content-text">{{ result.feature }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => {},
    },
    faceImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localhost: window.location.href.includes('m.ivydad'),
      shared: +this.$route.query.shared,
      tags: this.result.mean.split(/,|，|、|\s+/),
      book: this.result.represent.match(/《(\S*)》/)[0],
    }
  },
}
</script>
<style lang="less">
@import (reference) url(../../../project.less);
.name-result-content-container {
  background-image: url(../assets/background-border.png);
  background-color: #faefe1;
  .image-cover;
  width: 690px;
  height: 850px;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 52px 60px 60px 60px;
  margin: 0 auto;
  .title {
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 38px;
    color: #512c1c;
    padding-bottom: 8px;
  }
  .en-name {
    width: 448px;
    height: 94px;
    line-height: 94px;
    text-align: center;
    border-radius: 50px;
    background-color: #ffca90;
    font-family: Arial-BoldMT;
    font-size: 50px;
    color: #512c1c;
    margin: 0 auto;
  }
  .en-name-mark {
    text-align: center;
    padding-top: 17px;
    font-family: ArialMT;
    font-size: 30px;
    height: 33px;
    color: #512c1c;
  }
  .name-meaning-tags-box {
    margin: 0 -10px;
    padding-top: 10px;
    text-align: center;
    span {
      .inline-block;
      height: 50px;
      padding: 0 25px;
      font-family: PingFangSC-Medium;
      font-size: 26px;
      color: #512c1c;
      text-align: center;
      border: 2px solid #ffca90;
      border-radius: 58px;
      line-height: 50px;
      margin: 11px 10px;
    }
  }
  .ranking-text {
    padding-top: 20px;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: #512c1c;
    padding-bottom: 20px;
  }
  .human-card-box {
    .cells;
    width: 570px;
    height: 308px;
    background-color: #fff;
    border-radius: 30px;
    padding: 28px;
    box-sizing: border-box;
    .human-cover-box {
      width: 200px;
      height: 252px;
      img {
        display: block;
        width: 200px;
        height: 252px;
      }
    }
    .human-content-text {
      flex: 1;
      padding-left: 21px;
      color: #512c1c;
      .label {
        font-size: 24px;
      }
      .image-name {
        padding-top: 38px;
        font-size: 32px;
        font-weight: 600;
        strong {
          font-weight: 100;
        }
        span {
          .inline-block;
          font-size: 20px;
          color: #210000;
          padding-top: 14px;
          font-weight: normal;
        }
      }
      .content-text {
        padding-top: 28px;
        font-size: 24px;
        line-height: 34px;
      }
    }
  }
}
</style>
